import React, { useState } from 'react';
import ButtonIcon from 'automaailm-ui/lib/Components/ButtonIcon';

export interface IControlPasswordProps {
    id?: string;
    name?: string;
    value: string;
    onChange?: (event) => void;
    showPasswordButtonLabel: string;
}

export default function ControlPassword(props: IControlPasswordProps): JSX.Element {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [password, setPassword] = useState('');

    return (
        <React.Fragment>
            <div className="form-control-password">
                <input
                    type={isShowPassword ? 'text' : 'password'}
                    id={props.id}
                    name={props.name}
                    value={props.value}
                    onChange={(e) => {
                        setPassword(e.target.value);

                        if (props.onChange) {
                            props.onChange(e);
                        }
                    }}
                />
                <ButtonIcon
                    onClick={(e) => {
                        e.preventDefault();
                        setIsShowPassword(!isShowPassword);
                    }}
                    icon={isShowPassword ? 'eye-crossed' : 'eye'}
                />
            </div>
        </React.Fragment>
    );
}
